import React from 'react'
import { Dialog, List, Flex, Label, Checkbox } from '@leverege/ui-elements'

import style from './style.css'

export default function ListModal( {
  show,
  onClose,
  message,
  onClick,
  mtypes,
  flagName,
  flag,
  title,
  showFlag = false,
  onFlag
} ) {
  return (
    <Dialog.Message
      show={show}
      onClose={onClose}
      okay="Cancel"
      title={title}>
      {message}
      <List
        onClick={onClick}
        variant="modalSelect">
        {mtypes}
      </List>
      { showFlag ? (
        <Flex className={style.flag} variant="rowM">
          <Checkbox
            value={flag} 
            onChange={onFlag} />
          <Label>{flagName || 'Flag'}</Label>
        </Flex>
      ) : <div /> }
    </Dialog.Message>
  )
}
